import {Component, OnInit} from '@angular/core';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-logout-handler',
  standalone: true,
  imports: [],
  templateUrl: './logout-handler.component.html',
  styleUrl: './logout-handler.component.scss'
})
export class LogoutHandlerComponent implements OnInit {
    // questo Handler serve per intercettare il redirect dopo la logout di cognito per poter chiamare successivamente
    // la logout di cineca
    constructor() {
    }

    ngOnInit(): void {
        const cinecaLogoutUrl = environment.amplifyConfig.samlAuth.customCinecaLogoutUrl;

        if (cinecaLogoutUrl) {
            window.location.assign(cinecaLogoutUrl);
        } else {
            console.error("Logout CINECA non riuscito: URL non configurato.");
            window.location.assign('/');
        }
    }
}
